import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Trash2, Mail } from "lucide-react";

export default function SubmissionsAdmin() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);

  const load = () => api.get("/admin/submissions").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("¿Eliminar?")) return;
    await api.delete(`/admin/submissions/${id}`);
    load();
  };

  const markRead = async (id) => {
    await api.patch(`/admin/submissions/${id}/read`);
    load();
  };

  return (
    <div data-testid="cms-submissions">
      <div className="mb-8">
        <h1 className="text-2xl font-semibold text-[#0F2040]">Mensajes recibidos</h1>
        <p className="text-sm text-gray-600">Formularios de contacto enviados desde la web.</p>
      </div>

      <div className="bg-white border border-gray-200">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-xs uppercase tracking-wider text-gray-600">
            <tr>
              <th className="text-left px-5 py-3 w-8"></th>
              <th className="text-left px-5 py-3">Nombre</th>
              <th className="text-left px-5 py-3">Email</th>
              <th className="text-left px-5 py-3">Asunto</th>
              <th className="text-left px-5 py-3">Fecha</th>
              <th className="text-right px-5 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr><td colSpan={6} className="text-center py-12 text-gray-400">Sin mensajes.</td></tr>
            ) : items.map((s) => (
              <tr key={s.id} className={`border-t border-gray-100 hover:bg-gray-50 cursor-pointer ${!s.read ? "bg-[#fff8f9]" : ""}`} onClick={() => { setOpen(s); if (!s.read) markRead(s.id); }} data-testid={`submission-${s.id}`}>
                <td className="px-5 py-3">{!s.read && <span className="inline-block w-2 h-2 bg-[#C8102E] rounded-full"></span>}</td>
                <td className="px-5 py-3 font-medium text-[#0F2040]">{s.data?.name}</td>
                <td className="px-5 py-3 text-gray-600">{s.data?.email}</td>
                <td className="px-5 py-3 text-gray-600">{s.data?.subject || "—"}</td>
                <td className="px-5 py-3 text-gray-500 text-xs">{new Date(s.created_at).toLocaleString()}</td>
                <td className="px-5 py-3 text-right">
                  <button onClick={(e) => { e.stopPropagation(); remove(s.id); }} className="p-1.5 text-gray-400 hover:text-red-600">
                    <Trash2 className="w-4 h-4" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {open && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" onClick={() => setOpen(null)}>
          <div className="bg-white max-w-2xl w-full" onClick={(e) => e.stopPropagation()}>
            <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
              <h2 className="font-semibold text-[#0F2040]">Mensaje de {open.data?.name}</h2>
              <button onClick={() => setOpen(null)}>×</button>
            </div>
            <div className="p-6 space-y-3 text-sm">
              <p><strong>Email:</strong> <a href={`mailto:${open.data?.email}`} className="text-[#C8102E]">{open.data?.email}</a></p>
              <p><strong>Teléfono:</strong> {open.data?.phone || "—"}</p>
              <p><strong>Empresa:</strong> {open.data?.company || "—"}</p>
              <p><strong>Asunto:</strong> {open.data?.subject || "—"}</p>
              <hr />
              <p className="whitespace-pre-wrap">{open.data?.message}</p>
              <hr />
              <a href={`mailto:${open.data?.email}`} className="inline-flex items-center gap-2 bg-[#0F2040] text-white px-4 py-2 text-sm">
                <Mail className="w-4 h-4" /> Responder por email
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
